module.exports = __webpack_public_path__ + "static/media/2.c3c64dce.mp4";